import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonApostrofos';
const args = {};

export class OligonApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
